































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation } from 'vuex-class'
import UserMenu from '@/components/UserMenu.vue'
import Omnisearch from '@/modules/omnisearch/components/Omnisearch.vue';

@Component({
    components: {Omnisearch, UserMenu},
})
export default class ToolbarComponent extends Vue {
    @State(state => state.toolbar.title)
    public toolbarTitle: string

    @State(state => state.notification.center.unread)
    public unreadNotifications: number

    @State
    public permanentNavigation: boolean

    @State
    public darkMode: boolean

    @Mutation('showNotificationCenter')
    public showNotificationCenter: (show: boolean) => void

    public toolbarBorder = true

    get hasUnreadNotifications (): boolean {
        return !!this.$store.state.notification.center.unread
    }

    public back () {
        window.history.back()
    }
}
